import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

function WalletRedirect() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Determine redirect type from pathname
    const path = location.pathname;
    
    if (path.includes('/wallet/success')) {
      toast.success('Payment method added successfully!');
    } else if (path.includes('/wallet/collector-success')) {
      toast.success('Collector account setup completed!');
    } else if (path.includes('/wallet/refresh')) {
      toast('Please complete the setup process.', {
        icon: '🔄',
      });
    }

    // Redirect to wallet page after a brief delay
    const timer = setTimeout(() => {
      history.push('/app/wallet');
    }, 1000);

    return () => clearTimeout(timer);
  }, [location.pathname, history]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
        <p className="mt-4 text-gray-600 dark:text-gray-400">
          Redirecting to your wallet...
        </p>
      </div>
    </div>
  );
}

export default WalletRedirect;
